import {
  LocalVideoProvider,
  MeetingProvider,
  lightTheme,
} from 'amazon-chime-sdk-component-library-react'
import { RouteObject } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import { PATH } from '../constants'
import {
  AlexConnectFrame,
  CallbackFrame,
  CancelFrame,
  DialFrame,
  FinishFrame,
  MaintenanceFrame,
  MeetingFrame,
  SelectLanguageFrame,
  SelectRequirementFrame,
  SettingFrame,
  SystemMaintenanceFrame,
  TopFrame,
} from '../frames'
import { ContactProvider, DeviceIdProvider } from '../providers'
import { MeetingProvider as MeetingProviderCommon } from '../providers/MeetingProvider'

export const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <DeviceIdProvider>
        <ContactProvider>
          <TopFrame />
        </ContactProvider>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.root,
    element: (
      <DeviceIdProvider>
        <ContactProvider>
          <TopFrame />
        </ContactProvider>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.requirement,
    element: (
      <DeviceIdProvider>
        <ContactProvider>
          <SelectRequirementFrame />
        </ContactProvider>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.selectLanguage,
    element: (
      <DeviceIdProvider>
        <ContactProvider>
          <SelectLanguageFrame />
        </ContactProvider>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.dial,
    element: (
      <DeviceIdProvider>
        <ContactProvider>
          <MeetingProviderCommon>
            <MeetingProvider>
              <DialFrame />
            </MeetingProvider>
          </MeetingProviderCommon>
        </ContactProvider>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.alexConnect,
    element: (
      <DeviceIdProvider>
        <ContactProvider>
          <AlexConnectFrame />
        </ContactProvider>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.about,
    element: (
      <DeviceIdProvider>
        <ContactProvider>
          <MeetingProviderCommon>
            <MeetingProvider>
              <LocalVideoProvider>
                <ThemeProvider theme={lightTheme}>
                  <MeetingFrame />
                </ThemeProvider>
              </LocalVideoProvider>
            </MeetingProvider>
          </MeetingProviderCommon>
        </ContactProvider>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.finish,
    element: (
      <DeviceIdProvider>
        <ContactProvider>
          <FinishFrame />
        </ContactProvider>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.setting,
    element: (
      <DeviceIdProvider>
        <ContactProvider>
          <SettingFrame />
        </ContactProvider>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.callback,
    element: (
      <DeviceIdProvider>
        <MeetingProviderCommon>
          <ThemeProvider theme={lightTheme}>
            <CallbackFrame />
          </ThemeProvider>
        </MeetingProviderCommon>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.cancel,
    element: (
      <DeviceIdProvider>
        <MeetingProviderCommon>
          <CancelFrame />
        </MeetingProviderCommon>
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.maintenance,
    element: (
      <DeviceIdProvider>
        <MaintenanceFrame />
      </DeviceIdProvider>
    ),
  },
  {
    path: PATH.sytemMaintenance,
    element: (
      <DeviceIdProvider>
        <SystemMaintenanceFrame />
      </DeviceIdProvider>
    ),
  },
]
